// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"79c5a9aa","498":"2040b094","513":"c822950c","610":"6add01a5","787":"0506333e"}[chunkId] + ".chunk.js";
};